// jQuery wrapper
(function ($) {

	/**
	 ** Document ready
	 **/
	$(document).ready(function () {

		$('body').addClass('active');


		// InView - Animate when in viewport
		$('.animate').on('inview', function (event, isInView) {
			var element = $(this);

			if (isInView) {
				element.addClass('ani-trigger');
			}
		});
		$('.animate-bg').on('inview', function (event, isInView) {
			var element = $(this);

			if (isInView) {
				element.addClass('ani-trigger');
			}
		});
		$('.icon-cta-image').on('inview', function (event, isInView) {
			var element = $(this);

			if (isInView) {
				element.addClass('ani-trigger');
			}
		});


		// Hero video autoplay on interaction
		heroAutoplay();


		// Site Header style change with midnight.js
		// $('#site-logo').midnight();

		// Menu - Hamburger
		$('.menu-trigger').click(function (event) {
			event.preventDefault();

			var target = $(this).data('target');

			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(target).remove('active');
				$('body').removeClass('menu-open');

			} else {
				$(this).addClass('active');
				$(target).addClass('active');
				$('body').addClass('menu-open');
			}
		});


		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function (event) {
			event.preventDefault();
			var target = $(this).data('target');
			var headerHeight = $('#site-header').outerHeight();
			var scrollPosition = $(target).offset().top - (headerHeight);
			// var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
				scrollTop: scrollPosition
			}, 1000);
		});


		// Accordion list (FAQ setc.)
		if ($('.accordion-list').length > 0) {
			$('.accordion-list .answer:not(.active)').hide();
			// var allPanels = $('.accordion-list .answer');

			$('.accordion-list .accordion-toggle').click(function () {
				// var targetParent = $(this).data('parent');
				var target = $(this).data('target');

				// console.log(targetParent);

				if ($(target).hasClass('active')) {
					$(this).removeClass('current');
					$(target).removeClass('active').slideUp(250);

				} else {
					$('.accordion-list .accordion-toggle').removeClass('current');
					$('.accordion-list .answer').removeClass('active').slideUp(250);

					$(this).addClass('current');
					$(target).addClass('active').slideDown(250);
				}

				// Prevent default 'link' behaviour
				return false;
			});
		}

		// Projects / Case Studies accordion
		if ($('#projects').length > 0) {
			$('.accordion-list .accordion-toggle').click(function () {
				var img = $(this).data('image');

				$('#projects .project-img').removeClass('current');
				$(img).addClass('current');
			});
		}


		// News filter
		if ($('#news-filter').length > 0) {
			// Dropdowns Select2
			$('#cat').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				placeholder: 'Choose a category',
				//dropdownCssClass: 'filter_dropdown',
			});
			$('#archives-dropdown-2').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				placeholder: 'Choose a date',
				//dropdownCssClass: 'filter_dropdown',
			});
		}


		// Case Studies - Isotope / Masonry
		if ($('.page-case-studies .filter-list').length > 0) {
			// init Isotope
			var $grid = $('.page-case-studies .filter-list').isotope({
				itemSelector: '.item',
				layoutMode: 'fitRows'
			});

			// Multi-select filtering: allow toggling multiple terms (OR logic)
			// Buttons use `data-filter` attributes like ".term-slug" and ".all"
			$('#case-studies-filter').on('click', 'button', function (e) {
				e.preventDefault();
				var $btn = $(this);
				var filterValue = $btn.attr('data-filter');

				// If 'All' was clicked, clear other selections and show everything
				if (filterValue === '.all') {
					$('#case-studies-filter .filter-checkbox').removeClass('is-checked');
					$btn.addClass('is-checked');
					$grid.isotope({ filter: '*' });
					return;
				}

				// Toggle the clicked button
				$btn.toggleClass('is-checked');

				// Ensure 'All' is not checked when other filters are active
				$('#case-studies-filter .filter-checkbox[data-filter=".all"]').removeClass('is-checked');

				// Collect all active filters (excluding '.all')
				var active = [];
				$('#case-studies-filter .filter-checkbox.is-checked').each(function () {
					var val = $(this).attr('data-filter');
					if (val && val !== '.all') active.push(val);
				});

				// If no filters active, show all
				if (active.length === 0) {
					$grid.isotope({ filter: '*' });
					return;
				}

				// Build OR selector: '.term1, .term2'
				var filterString = active.join(', ');
				$grid.isotope({ filter: filterString });
			});
		}

		// Stat counters
		$('#statistics').on('inview', function (event, isInView) {
			if (!isInView) return;

			const numbers = document.querySelectorAll('#statistics span.number');

			numbers.forEach(function (el) {
				// Guard: don't re-animate if already started
				if (el.dataset.animated) return;
				el.dataset.animated = 'true';

				animateCounter(el);
			});
		});


		/***
		 * Carousels
		 ***/

		window.initSwipers = function () {
			const $allSwipers = $(".swiper");

			if ($allSwipers.length) {
				$allSwipers.each(function () {
					const type = $(this).attr("data-type");

					if (type === "services") {
						new Swiper(this, {
							slidesPerView: 1,
							spaceBetween: 0,
							centeredSlides: true,
							loop: true,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							breakpoints: {
								// Viewport width >= 992px
								992: {
									slidesPerView: 2.5,
								}
							}
						});
					} else if (type === "vacancies") {
						new Swiper(this, {
							slidesPerView: 1,
							spaceBetween: 20,
							centeredSlides: false,
							loop: true,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							navigation: {
								prevEl: '#vacancies .vacancies-prev',
								nextEl: '#vacancies .vacancies-next',
							},
							breakpoints: {
								// Viewport width >= 992px
								992: {
									slidesPerView: 3,
								}
							}
						});

					} else if (type === "testimonials") {
						new Swiper(this, {
							slidesPerView: 1,
							spaceBetween: 0,
							centeredSlides: false,
							loop: true,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							navigation: {
								prevEl: '#testimonials .testimonials-prev',
								nextEl: '#testimonials .testimonials-next',
							},
							effect: 'fade',
							fadeEffect: {
								crossFade: true
							},
						});

					} else if (type === "trusted") {
						new Swiper(this, {
							slidesPerView: 2,
							spaceBetween: 20,
							centeredSlides: false,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							loop: true,
							breakpoints: {
								// Viewport width >= 992px
								992: {
									slidesPerView: 3,
								},
								// Viewport width >= 1200px
								1200: {
									slidesPerView: 4,
								}
							}
						});
					} else if (type === "accreditation") {
						new Swiper(this, {
							slidesPerView: 2,
							spaceBetween: 20,
							centeredSlides: false,
							loop: true,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							breakpoints: {
								// Viewport width >= 992px
								992: {
									slidesPerView: 3,
								},
								// Viewport width >= 1200px
								1200: {
									slidesPerView: 4,
								}
							}
						});
					} else if (type === "team") {
						new Swiper(this, {
							slidesPerView: 1,
							spaceBetween: 20,
							centeredSlides: false,
							loop: true,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							breakpoints: {
								// Viewport width >= 992px
								992: {
									slidesPerView: 2,
								},
								// Viewport width >= 1200px
								1200: {
									slidesPerView: 3,
								}
							},
							navigation: {
								prevEl: '.team-controls .team-prev',
								nextEl: '.team-controls .team-next',
							},
						});
					} else if (type === "clients") {
						new Swiper(this, {
							slidesPerView: 2,
							spaceBetween: 20,
							centeredSlides: false,
							loop: true,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							breakpoints: {
								// Viewport width >= 992px
								992: {
									slidesPerView: 3,
								},
								// Viewport width >= 1200px
								1200: {
									slidesPerView: 4,
								}
							}
						});
					} else if (type === "activities") {
						new Swiper(this, {
							slidesPerView: 1,
							spaceBetween: 0,
							centeredSlides: false,
							loop: true,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							effect: 'fade',
							fadeEffect: {
								crossFade: true
							},
							navigation: {
								prevEl: '.activities-controls .activities-prev',
								nextEl: '.activities-controls .activities-next',
							},
						});
					} else if (type === "breaker") {
						new Swiper(this, {
							slidesPerView: 1,
							spaceBetween: 0,
							centeredSlides: false,
							loop: true,
							autoplay: {
								delay: 5000,
								disableOnInteraction: false,
							},
							effect: 'fade',
							fadeEffect: {
								crossFade: true
							},
							navigation: {
								prevEl: '.breaker-controls .breaker-prev',
								nextEl: '.breaker-controls .breaker-next',
							},
						});
					}

				});
			}
		};
		window.initSwipers();


		// Set Cookie function
		function createCookie(name, value, days) {
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				var expires = "; expires=" + date.toGMTString();
			} else var expires = "";
			document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
		}
		// Popout Cookie
		function melPopout() {
			// Check cookie 
			if ($.cookie('melPopout') != "accepted") {
				$('#popout').fadeIn();
				$('body').addClass('popout-open');
			}

			//Assign cookie on click
			$('#popout button, #popout a').on('click', function () {
				createCookie("melPopout", "accepted", 21); // Cookie expires in 21 days
				$('#popout').fadeOut();
				$('body').removeClass('popout-open');
			});
		}
		// Run cookie policy function
		melPopout();

	}); // End Document Ready


	// On load
	$(window).on('load', function () {

		// Header bar scrolled
		scrollbarState();

	});


	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

	});


	// On Resize
	$(window).on('resize', function () {

	});


	/***
	** Functions
	***/

	// Header bar scrolled
	function scrollbarState() {
		// Header bar height
		var navHeight = $('#site-header').outerHeight();

		if ($(document).scrollTop() > navHeight) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
			$('body').removeClass('scrolled');
			$('#site-header').removeClass('is-scrolled');
		}
	}


	// Hero video autoplay on interaction
	function heroAutoplay() {
		let videoLoaded = false;

		function loadVideo() {
			if (!videoLoaded) {
				document.querySelectorAll('.onload-iframe').forEach(function (iframe) {
					const baseSrc = iframe.getAttribute('data-src');
					iframe.setAttribute('src', baseSrc + '&autoplay=1');
					iframe.classList.add('loaded');
				});
				videoLoaded = true;
				// Remove event listeners after first trigger
				events.forEach(event => {
					document.removeEventListener(event, loadVideo);
				});
			}
		}

		const events = ['mousemove', 'click', 'keydown', 'touchstart'];
		events.forEach(event => {
			document.addEventListener(event, loadVideo, { once: true });
		});
	}


	// Homepage stat counters
	function animateCounter(el) {
		const rawValue = el.textContent.replace(/,/g, '').trim();
		const target = parseFloat(rawValue) || 0;
		const decimals = parseInt(el.dataset.decimals, 10) || 0;
		const formatter = new Intl.NumberFormat('en-US', {
			minimumFractionDigits: decimals,
			maximumFractionDigits: decimals,
		});
		const duration = 2000;
		const frameRate = 1000 / 60;
		const totalFrames = Math.round(duration / frameRate);
		let frame = 0;

		function easeOut(t) {
			return 1 - Math.pow(1 - t, 3);
		}

		const counter = setInterval(function () {
			frame++;
			const progress = easeOut(frame / totalFrames);
			const current = progress * target;

			el.textContent = formatter.format(current);

			if (frame === totalFrames) {
				el.textContent = formatter.format(target);
				clearInterval(counter);
			}
		}, frameRate);
	}

	// end jQuery wrapper
})(jQuery);